
let state = {
  dialogVisible: false,
  user: {},
  status: 0, //认证状态
  headerIndex: 0,
  showSys: false, //系统提示跳转
  sysType: 1, // 1--禁用 2--删除
  cateId: '', //大分类id
  percentage: 0,
  collectMusic: {},
  PutOnMusic:{},//当前播放的音乐信息,
  PutOnMusicUrl:'',//当前的音频，
  isPause:false,
  mouseLength:0,//页面中点击音频曲线的进度
  service:'',//客服二维码的路径
};
export default state;
